<select #selectEl class="form-select" [attr.id]="inputId" [attr.multiple]="multiple ? '' : null" [class]="selectClass">
  <ng-content></ng-content>
</select>
